import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { LD_Custom_Eases } from '../../assets/js/customEases';

gsap.registerPlugin( CustomEase );
// Establish Custom Eases
const ce = new LD_Custom_Eases();

// Declare constants
const listBeerContainerSelector = '.ldlb-beer';
// console.log("🚀 ~ listBeerContainerSelector:", listBeerContainerSelector)

window.addEventListener( 'DOMContentLoaded', event => {
  let listBeerContainers = document.querySelectorAll( listBeerContainerSelector );
	// console.log("🚀 ~ contentLoaded:" )

  if ( listBeerContainers.length > 0 ){
		listBeerContainers.forEach( thisBeerContainer => {
			let choices = thisBeerContainer.querySelectorAll('h4.beer-choice');
			let beerLists = thisBeerContainer.querySelectorAll('ul.list-beer');

			choices.forEach( thisChoice => {
				thisChoice.addEventListener( 'click', () => {
					let otherChoice = thisBeerContainer.querySelector('h4.beer-choice.active');

					if( false === thisChoice.classList.contains('active') ){
						otherChoice.classList.toggle('active');
						thisChoice.classList.toggle('active');

						beerLists.forEach( thisBeerList => {
							if( thisBeerList.getAttribute('data-target') === thisChoice.getAttribute('data-target') ){
								// Activate this one.
								gsap.to( thisBeerList, {
									x: 0,
									opacity: 1,
									duration: 0.3,
									delay: 0,
									ease: "entering",
									onStart: function(){
										thisBeerList.classList.toggle('active');
									}
								});
							}
							else {
								// Deactive this one.
								gsap.to( thisBeerList, {
									x: 50,
									opacity: 0,
									duration: 0.2,
									delay: 0.01, // need slight overlap so block doesn't change height
									ease: "exiting",
									onComplete: function(){
										thisBeerList.classList.toggle('active');
										gsap.set( thisBeerList, {
											x: -5
										});
									}
								});
							}
						});
					}
				})
			});

			let toggleSwitches = thisBeerContainer.querySelectorAll('.description-toggle-wrapper input[type="checkbox"]');

			if( toggleSwitches.length > 0 ) {
				toggleSwitches.forEach( toggleSwitch => {
					let toggleTarget = toggleSwitch.getAttribute('data-target');
					let thisList = thisBeerContainer.querySelector(`ul[data-target="${toggleTarget}"]`);
					let descriptions = thisList.querySelectorAll('.description');
					
					toggleSwitch.addEventListener('click', (event) => {
						// console.log("🚀 ~ thisList:", thisList)
						// console.log("🚀 ~ descriptions:", descriptions)

						if ( thisList.classList.contains('playing') ) {
							event.preventDefault();
							return;
						}
						thisList.classList.add('playing');

						if( thisList.classList.contains('toggle') ) {
							gsap.to( descriptions, {
								stagger: 0.1,
								height: 'auto',
								opacity: 1,
								onComplete: function(){
									thisList.classList.toggle('toggle');
									thisList.classList.remove('playing');
								}
							});
							
						} else {
							gsap.to( descriptions, {
								height: 0,
								opacity: 0,
								onComplete: function(){
									thisList.classList.toggle('toggle');
									thisList.classList.remove('playing');
								}
							});
						}
					});
				});
			}
		});
	}
});